import { createReducer } from './util';
import { RoxanneState } from '../typedefs/store';

const initialState: RoxanneState = {};

const handlers = {};

export default createReducer(initialState, handlers);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/roxanne.ts